import { SubjectRoles } from "@/api-schema-enums";

export const enum AttributeAppRolePrefix {
  Branch = "BH",
  Company = "CO",
  CompanyGroup = "CG",
}

/**
 * Generic function to extract attribute app roles based on a prefix.
 *
 * @param roles - Array of user roles
 * @param prefix - The prefix to filter by (e.g., "BH", "CO")
 * @returns Array of matching role strings
 */
export const extractAttributeAppRolesByPrefix = (
  roles: SubjectRoles[] | string[],
  prefix: AttributeAppRolePrefix,
): string[] => {
  if (!roles) return [];

  return roles.filter((role) => typeof role === "string" && role.startsWith(`${prefix}.`));
};
